module.exports = __webpack_public_path__ + "img/4d1d69f.svg";